import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';

// Pages
import Home from './pages/Home';
import Categories from './pages/Categories';
import Rules from './pages/Rules';
import RuleDetail from './pages/RuleDetail';
import Search from './pages/Search';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import ResendVerification from './pages/ResendVerification';
import Profile from './pages/Profile';
import Quiz from './pages/Quiz';
import ClubGuydom from './pages/ClubGuydom';
import GRAdmin from './pages/GRAdmin';
import RulesAdmin from './pages/RulesAdmin';
import StatusAdmin from './pages/StatusAdmin';
import UserAdmin from './pages/UserAdmin';
import StatsForNerds from './pages/StatsForNerds';
import SubmissionWorkflow from './pages/SubmissionWorkflow';
import QuizQuestions from './pages/QuizQuestions';
import GlossaryAdmin from './pages/GlossaryAdmin';
import Analytics from './pages/Analytics';
import NotFound from './pages/NotFound';

// Components
import ProtectedRoute from './components/ProtectedRoute';
import AnalyticsTracker from './components/Analytics';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <AnalyticsTracker />
        <div className="app">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categories" element={<Categories />} />
            <Route path="/rules" element={<Rules latest />} />
            <Route path="/rules/random" element={<Rules random />} />
            <Route path="/rules/latest" element={<Rules latest />} />
            <Route path="/rules/category/:id" element={<Rules />} />
            <Route path="/rules/:id" element={<RuleDetail />} />
            <Route path="/rules/:id/:slug" element={<RuleDetail />} />
            <Route path="/search" element={<Search />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/resend-verification" element={<ResendVerification />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route
              path="/club-guydom"
              element={
                <ProtectedRoute allowedProfiles={['admin', 'club']}>
                  <ClubGuydom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <GRAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/rules"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <RulesAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/statuses"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <StatusAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <UserAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/submission-workflow"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <SubmissionWorkflow />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/stats"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <StatsForNerds />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/quiz-questions"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <QuizQuestions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/glossary"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <GlossaryAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/analytics"
              element={
                <ProtectedRoute allowedProfiles={['admin']}>
                  <Analytics />
                </ProtectedRoute>
              }
            />
            {/* Catch-all route - MUST be last - redirects any unmatched routes to home */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
